import React, { useEffect, useState } from 'react'

import {
    Box,
    Text,
    Image,

    /* Hooks */
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'

import {
    Collapse,
} from '@chakra-ui/react'

import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

/* Styles */
import { useMyRewardsStyles } from '../styles/myRewardsStyles'

/* Icons */
import { ChevronDownIcon } from '../../../components/icons'

/* Hooks */
import { useOptimizely } from '../../../contexts/optimizely-context'

/* Utils */
import { generateStyles, getHideStyles } from '../../../components/optimizely/utils/utils'

const TIER_CIRCLE_COLORS = {
    creator: 'loyaltyT1',
    muse: 'loyaltyT2',
    icon: 'loyaltyT3'
}

const isComingSoon = (text) => typeof text === 'string' && /coming\s+soon/i.test(text.trim())

const getTierFromCard = (card, cardIndex) => {
    if (card?.tier && TIER_CIRCLE_COLORS[card.tier]) return card.tier
    const url = (card?.icon || '').toLowerCase()
    if (url.includes('creator')) return 'creator'
    if (url.includes('muse')) return 'muse'
    if (url.includes('icon.svg') || url.includes('/icon.') || (url.includes('icon') && (url.includes('.svg') || url.includes('tier')))) return 'icon'
    // CMS may use icon URL we can't parse; use position for 3-tier rows (creator, muse, icon)
    if (card?.icon && typeof cardIndex === 'number' && cardIndex >= 0 && cardIndex <= 2) return ['creator', 'muse', 'icon'][cardIndex]
    // Replace "Coming soon" placeholder with tier circle by position (e.g. $5 Off When You Reach 150 Points)
    if (isComingSoon(card?.text) && typeof cardIndex === 'number' && cardIndex >= 0 && cardIndex <= 2) return ['creator', 'muse', 'icon'][cardIndex]
    return null
}

const LoyaltyProgramDesktop = () => {
    const { rewardPageBlock } = useOptimizely()
    const styles = useMyRewardsStyles()
    const lpStyle = styles?.components?.loyaltyProgram

    const [openItems, setOpenItems] = useState({})

    const toggleItem = (tabIndex, contentIndex) => {
        const key = `${tabIndex}-${contentIndex}`
        setOpenItems(prev => ({
            ...prev,
            [key]: !prev[key]
        }))
    }
    const [cmsData, setCmsData] = useState(null)

    const breakpointTitle = useBreakpointValue({
        base: cmsData?.title?.mobileText,
        md: cmsData?.title?.tabletText,
        lg: cmsData?.title?.desktopText
    })

    const hardCodedDataDesktop = {
        title: {
            mobileText: 'Garage Collectif <span class="highlighted">benefits</span>',
            tabletText: 'What the Garage Collectif Can do <span class="highlighted">For You</span>',
            desktopText: 'What the Garage Collectif Can do <span class="highlighted">For You</span>',
        },
        backgroundImage: {
            desktopSrc: ''
        },
        levels: [{
            name: 'Creator',
            description: 'Free to join',
            background: 'warmWhite'
        }, {
            name: 'Muse',
            description: '300 points',
            background: 'warmWhite'
        }, {
            name: 'Icon',
            description: '600 points',
            background: 'warmWhite'
        }],
        tabs: [{
            name: 'The perks',
            contents: [{
                name: 'A special birthday gift from us',
                description: 'Available both in-store and online with a minimum purchase of $50+ on regular priced items!',
                cards: [{
                    icon: getAssetUrl('static/img/my-rewards/gift.svg'),
                    text: '£5',
                    background: '#FDECF6'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/gift.svg'),
                    text: '£15',
                    background: '#FDDFF1'
                }, {
                    icon: getAssetUrl('static/img/my-rewards/gift.svg'),
                    text: '£25',
                    background: '#EECEE1'
                }]
            }, {
                name: 'Early Access to Latest Collections',
                description: 'Garage Collectif members get special offers on select items throughout the year.',
                cards: [{
                    tier: 'creator',
                    text: null,
                    background: '#FDECF6'
                }, {
                    tier: 'muse',
                    text: null,
                    background: '#FDDFF1'
                }, {
                    tier: 'icon',
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Free Shipping on Your Online Orders',
                description: 'Garage Collectif members are eligible for free shipping on their orders depending on their tier.',
                cards: [{
                    icon: null,
                    text: '£50+',
                    background: '#FDECF6'
                }, {
                    icon: null,
                    text: '£40+',
                    background: '#FDDFF1'
                }, {
                    icon: null,
                    text: '£30+',
                    background: '#EECEE1'
                }]
            }]
        }, {
            name: 'The points',
            contents: [{
                name: 'Earn Points by Shopping & More',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    tier: 'creator',
                    text: null,
                    background: '#FDECF6'
                }, {
                    tier: 'muse',
                    text: null,
                    background: '#FDDFF1'
                }, {
                    tier: 'icon',
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: '$5 Off When You Reach 150 Points',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    tier: 'creator',
                    text: null,
                    background: '#FDECF6'
                }, {
                    tier: 'muse',
                    text: null,
                    background: '#FDDFF1'
                }, {
                    tier: 'icon',
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Double-Point Days',
                description: `Collectif Icon and Muse members will have access to surprise double-points days throughout the year. They'll earn twice the amount of points when shopping specific collections and categories.`,
                cards: [{
                    icon: null,
                    text: null,
                    background: '#FDECF6'
                }, {
                    tier: 'muse',
                    text: null,
                    background: '#FDDFF1'
                }, {
                    tier: 'icon',
                    text: null,
                    background: '#EECEE1'
                }]
            }]
        }, {
            name: 'The Extras',
            contents: [{
                name: 'Surprise Offers & Experiences',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    tier: 'creator',
                    text: null,
                    background: '#FDECF6'
                }, {
                    tier: 'muse',
                    text: null,
                    background: '#FDDFF1'
                }, {
                    tier: 'icon',
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Invites to Exclusive Collectif-Only Events',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: null,
                    text: null,
                    background: '#FDECF6'
                }, {
                    tier: 'muse',
                    text: null,
                    background: '#FDDFF1'
                }, {
                    tier: 'icon',
                    text: null,
                    background: '#EECEE1'
                }]
            }, {
                name: 'Customer Service Priority',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                cards: [{
                    icon: null,
                    text: null,
                    background: '#FDECF6'
                }, {
                    icon: null,
                    text: null,
                    background: '#FDDFF1'
                }, {
                    tier: 'icon',
                    text: null,
                    background: '#EECEE1'
                }]
            }]
        }]
    }

    const cmsDataModel = (rewardPageBlockData) => {
        return {
            title: {
                mobileText: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.MobileText,
                tabletText: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.TabletText,
                desktopText: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.DesktopText,
                ResponsiveTextBlockTextStyle: rewardPageBlockData?.BenefitsResponsiveText?.Expanded?.ResponsiveTextBlockTextStyle
            },
            backgroundImage: {
                desktopSrc: ''
            },
            levels: rewardPageBlockData?.BenefitsLevelBanner?.map(item => {
                const expanded = item.ContentLink.Expanded;
                return {
                    name: expanded.Title,
                    description: expanded.Description,
                    background: expanded.BackgroundColorOverride,
                    titleStyle: expanded.RewardBenefitsLevelTitleStyle,
                    descriptionStyle: expanded.RewardBenefitsLevelDescriptionStyle
                };
            }),
            tabs: rewardPageBlockData?.BenefitsSectionList?.map(section => {
                const expanded = section.ContentLink.Expanded;

                return {
                    name: expanded.Title,
                    titleStyle: expanded.RewardSectionBlockTitleStyle,
                    contents: expanded.RewardSectionTileList.map(tile => {
                        const tileExpanded = tile.ContentLink.Expanded;

                        return {
                            name: tileExpanded.Title,
                            description: tileExpanded.Description,
                            titleStyle: tileExpanded.RewardSectionTileBlockTitleStyle,
                            descriptionStyle: tileExpanded.RewardSectionTileBlockDescriptionStyle,
                            cards: tileExpanded.InfoTileList.map(info => {
                                const infoExpanded = info.ContentLink.Expanded;

                                return {
                                    icon: infoExpanded.IconMedia?.Expanded?.Url,
                                    text: infoExpanded.Title || null,
                                    background: infoExpanded.BackgroundColorOverride || '',
                                    titleStyle: infoExpanded.InfoTileBlockTitleStyle,
                                    titleBorderColor: infoExpanded.TitleBorderColor,
                                    titleBorderWidth: infoExpanded.TitleBorderWidth
                                };
                            })
                        };
                    }),
                    HideOnDevices: expanded.HideOnDevices
                };
            })
        }
    }

    useEffect(() => {
        if (rewardPageBlock) {
            const data = cmsDataModel(rewardPageBlock)
            setCmsData(data)
        } else {
            setCmsData(hardCodedDataDesktop)
        }
    }, [rewardPageBlock])

    const firstTabHideStyles = getHideStyles(cmsData?.tabs[0]?.HideOnDevices)

    return (
        <Box
            {...lpStyle.container}
            sx={{
                backgroundImage: `url(${getAssetUrl(cmsData?.backgroundImage.desktopSrc)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
            <Box {...styles.componentWrapper}>
                <Box
                    {...generateStyles(cmsData?.title?.ResponsiveTextBlockTextStyle, { ...styles.sectionTitle })}
                    sx={styles.highlighted}
                    dangerouslySetInnerHTML={{ __html: breakpointTitle }} />

                <Box {...lpStyle.heading}>
                    <Box {...lpStyle.levels}>
                        {cmsData?.tabs.length > 0 && cmsData?.tabs[0]?.name &&
                            <Text {...generateStyles(cmsData?.tabs[0].titleStyle, { ...lpStyle.accTitle })} {...firstTabHideStyles}>
                                {cmsData?.tabs[0]?.name}
                            </Text>
                        }
                        <Box {...lpStyle.levelsWrapper}>
                            {cmsData?.levels.map((level, levelIndex) => {
                                const tierKey = level?.name?.toLowerCase().replace(/\s+/g, '') || ['creator', 'muse', 'icon'][levelIndex]
                                const tierColor = TIER_CIRCLE_COLORS[tierKey] || TIER_CIRCLE_COLORS.creator
                                return (
                                    <Box {...lpStyle.level} sx={{ backgroundColor: 'var(--chakra-colors-warmWhite)' }} key={`level-${levelIndex}`}>
                                        <Box display="flex" alignItems="center" justifyContent="center" gap={2} flexDirection="row">
                                            <Box
                                                boxSize="14px"
                                                flexShrink={0}
                                                borderRadius="full"
                                                border="1px solid"
                                                borderColor="black"
                                                bg={tierColor}
                                            />
                                            <Text {...generateStyles(level?.titleStyle, { ...lpStyle.levelName })} sx={{ color: 'black' }}>
                                                {level.name}
                                            </Text>
                                        </Box>
                                        <Text {...generateStyles(level?.descriptionStyle, { ...lpStyle.levelDescription })} sx={{ color: 'black' }}>
                                            {level.description}
                                        </Text>
                                    </Box>
                                )
                            })}
                        </Box>
                    </Box>
                </Box>

                {cmsData?.tabs.map((tab, tabIndex) => {
                    const hideStyles = getHideStyles(tab.HideOnDevices)
                    return (
                        <Box {...lpStyle.accItem} sx={{ backgroundColor: 'var(--chakra-colors-white)' }} key={`tab-${tabIndex}`} {...hideStyles}>
                            {tabIndex > 0 &&
                                <Box {...lpStyle.accBtn}>
                                    <Box as='span' {...generateStyles(tab.titleStyle, { ...lpStyle.accTitle })}>
                                        {tab.name}
                                    </Box>
                                </Box>
                            }
                            <Box {...lpStyle.accPanel}>
                                {tab.contents.map((content, contentIndex) => {
                                    const itemKey = `${tabIndex}-${contentIndex}`
                                    const isOpen = openItems[itemKey] || false
                                    const isFreeShippingContent = content?.name?.toLowerCase().includes('free shipping')
                                    const isBirthdayGiftContent = content?.name?.toLowerCase().includes('birthday gift')
                                    const useWarmWhite = false

                                    return (
                                        <Box {...lpStyle.content} key={`content-${contentIndex}`} sx={isFreeShippingContent ? { backgroundColor: 'var(--chakra-colors-white)' } : undefined}>
                                            <Box {...lpStyle.nameAndDesc} onClick={() => toggleItem(tabIndex, contentIndex)}
                                                {...(!content.description && {cursor: 'unset'})}>
                                                <Text {...generateStyles(content.titleStyle, { ...lpStyle.contentName })}>
                                                    {content.name}
                                                    {content.description &&
                                                        <ChevronDownIcon
                                                            {...lpStyle.chevronIcon}
                                                            sx={{
                                                                ...lpStyle.chevronIcon?.sx,
                                                                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                transition: 'transform 0.2s ease-in-out'
                                                            }} />
                                                    }
                                                </Text>
                                                {content.description &&
                                                    <Collapse in={isOpen} animateOpacity>
                                                        <Text {...generateStyles(content.descriptionStyle, { ...lpStyle.contentDescription })}>
                                                            {content.description}
                                                        </Text>
                                                    </Collapse>
                                                }
                                            </Box>
                                            {content?.cards.length > 0 &&
                                                <Box {...lpStyle.cards}>
                                                    {content?.cards.map((card, cardIndex) => {
                                                        return (
                                                            <Box {...lpStyle.card} sx={{ backgroundColor: useWarmWhite ? 'var(--chakra-colors-warmWhite)' : 'var(--chakra-colors-white)' }} key={`card-${cardIndex}`}>
                                                                {(isBirthdayGiftContent && card?.icon) ? (
                                                                    <Image {...lpStyle.cardIcon} src={card.icon} alt="" />
                                                                ) : getTierFromCard(card, cardIndex) ? (
                                                                    <Box boxSize="14px" flexShrink={0} borderRadius="full" border="1px solid" borderColor="black" bg={TIER_CIRCLE_COLORS[getTierFromCard(card, cardIndex)]} marginRight={1} />
                                                                ) : card?.icon ? (
                                                                    <Image {...lpStyle.cardIcon} src={card.icon} alt="" />
                                                                ) : null}
                                                                {card?.text && !isComingSoon(card.text) &&
                                                                    <Text {...generateStyles(card.titleStyle, { ...lpStyle.cardText })}
                                                                        {...(card?.titleBorderColor || card?.titleBorderWidth) && {
                                                                            border: `${card?.titleBorderWidth || '1px'} solid`,
                                                                            borderColor: card?.titleBorderColor || 'black',
                                                                            p: '1px 8px 4px',
                                                                            lineHeight: '100%'
                                                                        }}>
                                                                        {card.text}
                                                                    </Text>
                                                                }
                                                            </Box>
                                                        )
                                                    })}
                                                </Box>
                                            }
                                        </Box>
                                    )
                                })}
                            </Box>
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

export default LoyaltyProgramDesktop
